/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentBarcodeLookupIfNotRequested } from 'state/current-barcode-lookup/actions';
import { getCurrentBarcodeLookup, requestingCurrentBarcodeLookup } from 'state/current-barcode-lookup/selectors';
import PlanLoader from './plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';


/**
 * Style dependencies
 */
import './styles.scss';

const CurrentBarcodeLookupPlanCard = (props) => {
	let currentBarcodeLookup = props.currentBarcodeLookup;

	useEffect(() => {
		props.requestCurrentBarcodeLookup();
	}, []);

	if (!currentBarcodeLookup && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentBarcodeLookup && props.requesting) {
		return <PlanLoader />;
	}

	return (
		<Stack space='xxlarge'>
				
		    {currentBarcodeLookup.map((barcodelookup) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={barcodelookup.plan_id} />
									</Box>
									<Box>
									    Price:
										<Money value={barcodelookup.plan_unit_price / 100} /> /{' '}
										{barcodelookup.billing_period} {barcodelookup.billing_period_unit}
						         	</Box>
						         	{barcodelookup.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={barcodelookup.next_billing_at} />
						         	</Box>
						         	)}

						         	{barcodelookup.addons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Addons
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{barcodelookup.addons.map(({ unit_price, quantity, amount, id }) => {
													return (
														<Box
															key={id}
															display='flex'
															alignItems='center'
															justifyContent='spaceBetween'
														>
															<Text size='small' padding='small'>
															    {id} {' '}
																<Money value={amount / 100} /> ( x {quantity})
															</Text>
														</Box>
													);
												})}
											</Stack>
										</Box>
								
								    )}

								    {barcodelookup.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{barcodelookup.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									<Box>
										<SubscriptionStatus status={barcodelookup.status} />
									</Box>
									{barcodelookup.status == 'future' && (
									<Box>
										Subscription start date: 
										{<DateTime date={barcodelookup.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}
						         	
								</Stack>
							</Box>
							
						</Card.Section></Stack></Card>)
		    })}
			
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentBarcodeLookup: getCurrentBarcodeLookup(state),
		requesting: requestingCurrentBarcodeLookup(state),
	}),
	{
		requestCurrentBarcodeLookup: requestCurrentBarcodeLookupIfNotRequested,
	},
)(CurrentBarcodeLookupPlanCard);
